import type { NearbyShip } from "../hooks/usePrevetAPI"
import styles from "./nearbyShipPopup.module.scss"

const finiteOrZero = (value: number | null | undefined): number =>
  typeof value === "number" && Number.isFinite(value) ? value : 0

export function nearbyShipPopup(
  ship: NearbyShip,
  category?: "laden" | "ballast",
  segmentName?: string
): HTMLElement {
  const content = document.createElement("div")
  const line = (text: string, className?: string) => {
    const element = document.createElement("div")
    element.textContent = text
    if (className) element.className = className
    content.appendChild(element)
    return element
  }
  line(ship.vessel_name || `IMO ${ship.imo}`, "fw-bold")
  if (segmentName) line(segmentName)
  line(`Speed : ${finiteOrZero(ship.sog).toFixed(1)} kt`)
  if (category) line(category.toUpperCase(), `fw-bold ${styles[category]}`)
  line(`Destination : ${ship.master_destination ?? ""}`)
  line(`Draft Ratio : ${finiteOrZero(ship.draft_ratio)}`)
  line(`ETA : ${ship.master_eta ?? ""}`)
  const margin = finiteOrZero(ship.margin_pct)
  const row = line("Sea Margin: ", `text-${margin > 10 ? "danger" : margin > 6 ? "warning" : "success"}`)
  const value = document.createElement("span")
  value.className = "text-black fw-bold"
  value.textContent = `${margin.toFixed(2)}%`
  row.appendChild(value)
  return content
}
